import { Component, Input, ViewChild, NgZone, Output } from '@angular/core';
import { AutosizeModule } from 'ngx-autosize';
import { ToolsProvider } from '../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as $ from 'jquery';
import { ModalController } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ImageSelectorProvider } from '../../providers/image-selector/image-selector';
import { EventEmitter as EventEmitter2 } from '../../includes/eventEmitter';
import { UserVerificationProvider } from '../../providers/user-verification/user-verification';
import { MediaSelectorProvider } from '../../providers/image-selector/media-selector';
import { CameraSource } from '@capacitor/camera';

@Component({
  selector: 'add-comment',
  templateUrl: 'add-comment.html',
})
export class AddCommentComponent extends EventEmitter2 {
  log = debug('app:AddCommentComponent');

  @Input() post: any = {};
  @ViewChild('element') element;
  @ViewChild('commentTextarea') commentTextarea;

  engagement: any = {
    post: '',
    commentInformation: {
      text: '',
    },
    engagementType: 'COMMENT',
    stats: {
      comments: 0,
      shares: 0,
      likes: 0,
    },
  };
  results = {
    people: [],
    peopleMax: 10,
    loadingMorePeople: false,
  };
  type = 'comment';
  buttonText = 'Comment';
  textareaText = 'Write a comment ...';
  replyTo = '';
  editingComment = false;
  commentEditingId = '';
  savedEngagement: any = {};
  subs: any = [];
  giphyUrl = '';
  imageUrl = '';
  videoUrl = '';
  sendingMedia = false;
  processingCommentOrReply = false;
  inputAttributes;
  postContent = '';
  searchId;
  showTaggingList = false;
  taggingUser = false;
  taggedUsers = [];
  userSearch = '';
  inputType = '';

  constructor(
    public tools: ToolsProvider,
    public zone: NgZone,
    public modalCtrl: ModalController,
    public user: UserProvider,
    public imageSelector: ImageSelectorProvider,
    public userVerification: UserVerificationProvider,
    public crudApi: CrudApiProvider,
    public mediaSelector: MediaSelectorProvider
  ) {
    super();
    this.log('constructed');
    window['__AddCommentComponent'] = this;
  }

  ngOnInit() {
    this.resetInputAttributes();
    this.subs.push(
      this.on('addCommentSuccess', () => {
        this.tools.emit('addCommentSuccess');
        this.giphyUrl = '';
        this.imageUrl = '';
        this.videoUrl = '';
        _.set(this, 'engagement', {
          post: '',
          commentInformation: {
            text: '',
          },
          engagementType: 'COMMENT',
          stats: {
            comments: 0,
            shares: 0,
            likes: 0,
          },
        });
        this.resetInputAttributes();
      })
    );
    this.subs.push(
      this.on('addCommentError', engagement => {
        setTimeout(() => {
          this.giphyUrl = '';
          this.imageUrl = '';
          this.videoUrl = '';
          _.set(this, 'engagement', {
            post: '',
            commentInformation: {
              text: '',
            },
            engagementType: 'COMMENT',
            stats: {
              comments: 0,
              shares: 0,
              likes: 0,
            },
          });
          this.resetInputAttributes();
        }, 500);
      })
    );

    // editComment
    this.subs.push(
      this.on('editComment', c => {
        this.log('editing comment', c);
        _.set(
          this.engagement,
          'commentInformation.text',
          _.get(c.commentInformation, 'text')
        );

        this.taggedUsers = _.get(c, 'taggedUsers') || [];

        if (_.get(c.commentInformation, 'giphyUrl')) {
          _.set(this, 'giphyUrl', _.get(c.commentInformation, 'giphyUrl'));
          _.set(this.engagement, 'commentInformation.giphyUrl', null);
          _.set(c, 'commentInformation.giphyUrl', null);
          this.sendingMedia = true;
        }

        if (_.get(c.commentInformation, 'imageUrl')) {
          _.set(this, 'imageUrl', _.get(c.commentInformation, 'imageUrl'));
          _.set(this.engagement, 'commentInformation.imageUrl', null);
          _.set(c, 'commentInformation.imageUrl', null);
          this.sendingMedia = true;
        }

        _.set(this, 'commentEditingId', c._id);
        this.editingComment = true;
        this.focusTextarea();
        this.resetInputAttributes();
      })
    );

    // focusAddReply
    this.subs.push(
      this.on('focusAddReply', comment => {
        if (!this.checkLoggedIn()) {
          return;
        }
        this.log('focusing for reply', comment);

        // resetting for changing comment

        this.engagement = {
          post: '',
          commentInformation: {
            text: '',
          },
          engagementType: 'COMMENT',
          stats: {
            comments: 0,
            shares: 0,
            likes: 0,
          },
        };

        if (_.get(comment, 'parentComment')) {
          this.engagement.parentReply = _.get(comment, '_id');
          this.engagement.parentReplyObjTmp = comment;
          this.type = 'reply';
          this.replyTo =
            '<span>Replying to:  <b>' +
            (_.get(comment.user, 'firstName') ||
              _.get(comment.user, 'lastName')) +
            '</b></span>';
        } else if (_.get(comment, 'user')) {
          this.type = 'comment';
          this.replyTo =
            '<span>Replying to:  <b>' +
            (_.get(comment.user, 'firstName') ||
              _.get(comment.user, 'lastName')) +
            '</b></span>';
        } else {
          this.type = 'comment';
          this.replyTo = '';
        }

        this.engagement.parentComment =
          _.get(comment, 'parentComment') || _.get(comment, '_id');

        this.engagement.post = _.get(comment, 'post');
        this.buttonText = 'Reply';
        this.textareaText = 'Write a reply ...';
        this.log('focusing for reply, engagement setup', this.engagement);
        this.resetInputAttributes();
        this.focusTextarea();
      })
    );
  }

  ngOnDestroy() {
    _.each(this.subs, s => {
      if (s instanceof Function) {
        s();
      } else if (s.unsubscribe) {
        s.unsubscribe();
      }
    });
  }

  checkLoggedIn() {
    if (!this.user.userPermission('comment')) {
      try {
        window.event.preventDefault();
        window.event.stopPropagation();
      } catch (e) {}
      return this.tools.loginBlock('You must be logged in to comment.');
    } else {
      return true;
    }
  }

  update() {
    if (!this.user.userPermission('comment')) {
      return this.tools.loginBlock('You must be logged in to like a post.');
    }
    this.processingCommentOrReply = true;

    this.log('comment editing', this.commentEditingId, this.engagement);
    _.set(this.engagement, '_id', this.commentEditingId);
    if (this.giphyUrl) {
      _.set(this.engagement, 'commentInformation.giphyUrl', this.giphyUrl);
    }
    if (this.imageUrl) {
      _.set(this.engagement, 'commentInformation.imageUrl', this.imageUrl);
    }
    if (this.videoUrl) {
      _.set(this.engagement, 'commentInformation.videoUrl', this.videoUrl);
    }

    if (_.size(this.taggedUsers)) {
      const userIds = _.map(this.taggedUsers, '_id');
      this.engagement.taggedUsers = userIds;
      this.tools.logAnalyticsEvent('trackCustom', 'edit-comment-tagged-users', {
        usernames: _.map(this.taggedUsers, 'username'),
        userIds: userIds,
        size: _.size(this.taggedUsers),
      });
      this.taggedUsers = [];
      this.showTaggingList = false;
    }

    this.emit(
      `updateComment-${_.get(this.engagement, '_id')}`,
      this.engagement
    );

    this.clearReply();
  }

  async submit() {
    // we are allowing unverified users to comment as of 3/9/2023
    if (await this.userVerification.isRiskyAndNotVerified()) {
      return;
    }

    if (_.size(this.taggedUsers)) {
      const userIds = _.map(this.taggedUsers, '_id');
      this.engagement.taggedUsers = userIds;
      this.tools.logAnalyticsEvent('trackCustom', 'add-comment-tagged-users', {
        usernames: _.map(this.taggedUsers, 'username'),
        userIds: userIds,
        size: _.size(this.taggedUsers),
      });
    }

    if (!this.user.userPermission('comment')) {
      return this.tools.loginBlock('You must be logged in to like a post.');
    }

    this.processingCommentOrReply = true;

    if (_.get(this, 'giphyUrl')) {
      _.set(
        this.engagement.commentInformation,
        'giphyUrl',
        _.get(this, 'giphyUrl')
      );
    } else {
      delete this.engagement.commentInformation.giphyUrl;
    }

    if (_.get(this, 'imageUrl')) {
      _.set(
        this.engagement.commentInformation,
        'imageUrl',
        _.get(this, 'imageUrl')
      );
    }
    if (_.get(this, 'videoUrl')) {
      _.set(
        this.engagement.commentInformation,
        'videoUrl',
        _.get(this, 'videoUrl')
      );
    } else {
      delete this.engagement.commentInformation.videoUrl;
    }
    this.log('engagment %O', this.engagement.commentInformation);
    this.submitText();

    this.showTaggingList = false;
  }

  async submitText() {
    // we are allowing unverified users to comment as of 3/9/2023
    if (await this.userVerification.isRiskyAndNotVerified()) {
      return;
    }

    if (
      !_.get(this, 'engagement.commentInformation.text') &&
      !_.get(this, 'engagement.commentInformation.giphyUrl') &&
      !_.get(this, 'engagement.commentInformation.imageUrl') &&
      !_.get(this, 'engagement.commentInformation.videoUrl')
    ) {
      this.processingCommentOrReply = false;
      return;
    }

    this.savedEngagement = _.cloneDeep(this.engagement);

    if (_.get(this, 'post.engagementType') === 'COMMENT') {
      this.log('threads addReply', this.engagement, this.post);
      _.set(this.engagement, 'parentComment', _.get(this, 'post._id'));
      _.set(this.engagement, 'post', _.get(this, 'post.post'));
      this.log('threads addReply', this.engagement, this.post);
    } else {
      _.set(this.engagement, 'post', _.get(this, 'post._id'));
    }

    if (!_.get(this.engagement, 'post')) {
      return;
    }
    this.log('ADDCOMMENT submit: ', this.engagement);
    this.log('ADDCOMMENT type: ', this.type);
    let engagement: any = _.get(this, 'engagement');

    if (this.type === 'reply') {
      // Replying to a reply
      this.log(
        `ADDCOMMENT emit reply to reply: addReply-${engagement.parentReply}`,
        engagement
      );
      this.emit(`addReply-${engagement.parentComment}`, engagement);
    } else if (this.type === 'comment' && _.get(engagement, 'parentComment')) {
      // Replying to a reply
      this.log(
        `ADDCOMMENT emit comment: addReply-${engagement.parentComment}`,
        engagement
      );
      this.emit(`addReply-${engagement.parentComment}`, engagement);
    } else {
      // Commenting
      this.log('ADDCOMMENT emit - addComment', engagement);
      this.emit(`addComment`, engagement);
    }

    engagement.taggedUsers = this.taggedUsers;
    this.tools.emit(`post-comment-${engagement.post}`, engagement);
    this.clearReply();
  }

  clearReply() {
    this.processingCommentOrReply = false;
    this.type = 'comment';
    this.giphyUrl = '';
    this.imageUrl = '';
    this.videoUrl = '';
    this.sendingMedia = false;
    this.buttonText = 'Comment';
    this.textareaText = 'Write a comment ...';
    this.replyTo = '';
    this.editingComment = false;
    this.showTaggingList = false;
    this.taggedUsers = [];

    this.emit('clearingCommentInput');

    this.engagement = {
      post: '',
      commentInformation: {
        text: ' ',
      },
      engagementType: 'COMMENT',
    };

    // some weird svelte thing going on
    this.resetInputAttributes();
    this.engagement.commentInformation.text = '';
    setTimeout(() => {
      this.resetInputAttributes();
    });
  }

  getGiphy() {
    this.log('getting gif');
    const modal = this.modalCtrl.create('GiphyPage');

    modal.onDidDismiss(url => {
      this.log('got Giphy', url);
      if (url) {
        this.giphyUrl = url;
        this.imageUrl = '';
        this.videoUrl = '';
        this.sendingMedia = true;
        this.resetInputAttributes();
      }
    });

    modal.present();
  }

  async getPhoto(opts = {}) {
    this.log('getting photo');

    event.stopImmediatePropagation();

    const images = await this.mediaSelector.getMediaByType('photo');

    this.log('save post', images);

    this.imageUrl = _.get(_.head(images), 'url');
    this.giphyUrl = '';
    this.sendingMedia = true;
    this.resetInputAttributes();
  }

  getVideo() {
    this.log('getting video');

    event.stopImmediatePropagation();
    this.imageSelector
      .getVideo()
      .then(
        res => {
          this.log('presentAddPhotoActionSheet', res);
          if (res) {
            this.videoUrl = res;
            this.giphyUrl = '';
            this.imageUrl = '';
            this.sendingMedia = true;
            this.resetInputAttributes();
            return res;
          }
        },
        e => {
          this.log('presentAddPhotoActionSheet Error', e);
        }
      )
      .catch(e => {
        this.log('presentAddPhotoActionSheet Error', e);
      });
  }

  async onChange(data) {
    if (this.taggedUsers) {
      this.engagement.commentInformation.text = _.get(
        this.commentTextarea,
        'nativeElement.lastElementChild.children.1.value'
      );
    } else {
      this.engagement.commentInformation.text =
        _.get(data, 'detail.value') || '';
    }

    this.tools.emit('onKeyboardShow');
    await this.toggleTagging(data);
    await this.handleTagging(data);
  }

  doSearch(forceSearch = false) {
    if (this.userSearch.length === 0) {
      this.results = {
        people: [],
        peopleMax: 10,
        loadingMorePeople: false,
      };
    }

    let st = this.userSearch
        .replace(/“/g, '"')
        .replace(/”/g, '"')
        .replace(/@/g, ''),
      autocompleteOnly = false;

    if (forceSearch) {
      autocompleteOnly = false;
    } else {
      autocompleteOnly = _.size(st) <= 2;
    }

    this.log('starting user tagging search', st);

    this.searchId = _.uniqueId();

    Promise.all(
      [!autocompleteOnly && this.peopleSearch(st, this.searchId)].filter(d => d)
    ).then(() => {
      // Done
      this.log('results', this.results);
      this.rankingResults();
    });
  }

  private rankingResults() {
    // ranking people
    const exactMatchPeople = _.filter(this.results.people, item => {
      const name = `${_.trim(item.firstName)} ${_.trim(item.lastName)}`;
      const nameLower = _.toLower(name);
      if (nameLower) {
        return (
          nameLower === _.trim(_.toLower(this.userSearch)) ||
          _.trim(_.toLower(item.username)) ===
            _.trim(_.toLower(this.userSearch))
        );
      }
    });

    _.map(exactMatchPeople, match => {
      _.remove(this.results.people, people => {
        return people === match;
      });
      this.results.people.unshift(match);
    });
  }

  private async peopleSearch(stringText: string, id) {
    try {
      const { data } = await this.crudApi.get('/api/search/users', {
        text: stringText,
      });

      // still active
      if (this.searchId === id) {
        this.results.people =
          _.each(
            data,
            u => (u.localUsername = _.replace(u.username, / +/g, '_'))
          ) || [];
        this.results.peopleMax = 10;
        await this.loadMorePeople(0);
      }
    } catch (error) {
      this.log('Error getting people', error);
    } finally {
    }
  }

  async loadMorePeople(n = 5) {
    this.results.peopleMax += n;
    this.results.loadingMorePeople = true;
    this.log('loading more people');
    await Promise.all(
      _.map(this.results.people, (p, idx) => {
        if (idx < this.results.peopleMax) {
          return this.crudApi
            .get(`/api/friends/${this.user.get('_id')}/${p._id}`)
            .then(res => {
              this.log('got friendship', res);
              if (res.data) {
                p.friendship = res.data;
              } else {
                p.noFriendship = true;
              }
            });
        }
      }).filter(d => d)
    );
    this.results.loadingMorePeople = false;
  }

  async toggleTagging(e) {
    this.showTaggingList = true;
    const regexLetterNumbers = /^[a-zA-Z0-9]+$/;
    const userAnchor = /@[\w.]+/g;
    const currentWord = await this.findCurrentWordTyping();

    if (_.get(e, 'detail.value') === '@' || userAnchor.test(currentWord)) {
      this.log('handleTagging | setting TRUE');
      this.taggingUser = true;
      if (_.get(e, 'detail.value') === '@') {
        this.tools.logAnalyticsEvent(
          'trackCustom',
          'add-comment-tagged-users-started'
        );
      }
    } else if (!regexLetterNumbers.test(_.get(e, 'detail.value'))) {
      this.log('handleTagging | setting FALSE');
      this.taggingUser = false;
    }
  }

  async handleTagging(e) {
    const currentWord = await this.findCurrentWordTyping();
    const currentUsername = _.replace(_.clone(currentWord), '@', '');
    this.log('handle tagging', e, this.commentTextarea);
    if (this.taggingUser) {
      this.log(
        'handleTagging | userSearch ' + `W:${currentWord} U:${currentUsername}`
      );
      this.userSearch = currentUsername;
      if (_.size(this.userSearch)) this.doSearch();
    }

    this.taggingHandleRemoves(e, currentWord, currentUsername);
  }

  onDelete(e: InputEvent) {
    this.log('onDelete', e);
    this.inputType = e.inputType;
    setTimeout(() => {
      this.inputType = null;
    }, 250);
  }

  async taggingHandleRemoves(e, currentWord, username) {
    const userAnchor = /@[\w.]+/g;
    const inputValue = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.value'
    );

    if (!_.size(inputValue)) {
      this.taggedUsers = [];
      this.userSearch = '';
      return;
    }

    this.log(
      'handleTagging | backspace testing',
      _.size(currentWord),
      currentWord
    );

    if (
      this.inputType === 'deleteContentBackward' &&
      userAnchor.test(currentWord) &&
      _.size(currentWord) >= 4
    ) {
      // remove taggedUser if match
      const partialRegex = new RegExp(`^.*${username}.*$`, 'i');
      const filtered = _.filter(this.taggedUsers, user => {
        const test = partialRegex.test(user.localUsername);
        this.log(
          'handleTagging | backspace testing',
          user.username,
          username,
          test
        );
        return test ? null : user;
      });

      this.taggedUsers = filtered;
      this.log('handleTagging | taggedUsers filtered', this.taggedUsers);
    }
  }

  async findCurrentWordTyping() {
    let cursorStart = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.selectionStart'
    );

    let cursorEnd = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.selectionEnd'
    );

    // Get the content of the textarea

    let inputValue = _.get(
      this.commentTextarea,
      'nativeElement.lastElementChild.children.1.value'
    );

    // Use a regular expression to extract the word at the cursor position
    let wordsArray = this.tools.taggingWords(inputValue);

    this.log('handleTagging | findCurrentWordTyping | words: ', wordsArray);
    this.log(
      'handleTagging | findCurrentWordTyping | start & end ',
      cursorStart,
      cursorEnd
    );
    // Find the word at the cursor position
    let currentWord = null;
    let skipCharacters = 0;
    if (wordsArray) {
      for (var i = 0; i < wordsArray.length; i++) {
        let wordStart = inputValue.indexOf(wordsArray[i], skipCharacters);
        let wordEnd = wordStart + wordsArray[i].length;

        skipCharacters += wordEnd - wordStart;

        this.log(
          'handleTagging | findCurrentWordTyping | word',
          wordStart,
          wordsArray[i] || 'WORD NOT FOUND',
          wordEnd
        );

        if (cursorStart >= wordStart && cursorEnd <= wordEnd) {
          currentWord = wordsArray[i];
          break;
        }
      }
    }

    this.log('handleTagging | findCurrentWordTyping | current: ', currentWord);

    return currentWord;
  }

  resetInputAttributes() {
    this.inputAttributes = null;
    setTimeout(() => {
      this.inputAttributes = {
        placeholder: this.textareaText,
        can_submit: this.imageUrl || this.giphyUrl || this.videoUrl,
        images: this.imageUrl
          ? [this.imageUrl]
          : this.giphyUrl
          ? [this.giphyUrl]
          : this.videoUrl
          ? [this.videoUrl]
          : [],
        value: this.engagement.commentInformation.text || '',
        type: 'messageTextArea',
      };

      if (_.size(this.taggedUsers)) {
        setTimeout(() => {
          this.showTaggingList = true;
        });
      }
    });
  }

  focusTextarea() {
    doIt.call(this);

    // in case resetInputAttributes is running
    setTimeout(doIt.bind(this), 10);
    setTimeout(doIt.bind(this), 200);
    setTimeout(doIt.bind(this), 400);
    setTimeout(doIt.bind(this), 700);
    setTimeout(doIt.bind(this), 1000);

    function doIt() {
      const el =
        this.commentTextarea && _.get(this.commentTextarea, 'nativeElement');
      if (el) {
        try {
          el.querySelector('textarea').focus();
        } catch (e) {}
      }
    }
  }

  removeImage() {
    this.giphyUrl = '';
    this.imageUrl = '';
    this.videoUrl = '';
    this.sendingMedia = false;
    this.resetInputAttributes();
    this.tools.emit('onKeyboardShow');
  }
}



// WEBPACK FOOTER //
// ./src/components/add-comment/add-comment.ts